import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import ContactAvatar from 'flow/components/ui-components/ContactAvatar';
import { selectContact } from 'flow/selectors/ExtensionSelectors';
import { ExtensionKey } from 'flow/types/EntityKeys';

type Props = {
    assigneeKey: ExtensionKey;
    muted?: boolean;
};

const AssigneeChipAvatar = ({ assigneeKey, muted }: Props) => {
    const assigneeContact = useAppSelector((state) =>
        selectContact(state, assigneeKey),
    );

    const avatar = (
        <ContactAvatar
            contact={assigneeContact}
            size="tiny"
            shouldUseDefaultIfNoFirstNameAndNoLastName={true}
        />
    );

    // Closed tickets fade the avatar. The wrapper re-establishes flex
    // centering that the avatar gets for free as a direct chip flex child.
    if (muted) {
        return <span className="flex items-center opacity-70">{avatar}</span>;
    }

    return avatar;
};

export default React.memo(AssigneeChipAvatar);
